
<div class="w-100" style="height: calc(100% - 40px);">
    <p-inspection-contact-card
        v-for     = "(contact, index) in contacts"
        :key      = "index"
        :contact  = "contact"
        class     = "mb-4"
        @favorite = "onFavorite"
    />
</div>
